import { PopUp, Show } from "components";

import { useEffect, useState, type FC } from "react"
import { clearAuth } from "_graphql/cache/auth";
import { wrapClick } from "utils";

type LogoutContainerProps = {
    open: boolean;
    setOpen: (val: boolean) => void;
    type?: "prompt" | "confirm";
}

const LogoutContainer: FC<LogoutContainerProps> = ({ open, setOpen, type = "confirm" }) => {
    const [countdown, setCountdown] = useState(60);
    useEffect(() => {
        if (type === "prompt" && open) {
            const timer = setInterval(() => {
                setCountdown((prev) => {
                    if (prev <= 1) {
                        clearAuth();
                        setOpen(false);
                        return 60; // Reset countdown
                    }
                    return prev - 1;
                });
            }, 1000);

            return () => clearInterval(timer);
        }
    }, [open, type, setOpen]);
    return (
        <PopUp
            title={type === "prompt" ? "You are about to log out" : "Confirm Logout"}
            description={type === "prompt" ? "You have been idle for a while, the system will log you out after the timer runs down" : "Are you sure you want to log out? This action cannot be undone."}
            open={open}
            setOpen={setOpen}
            placement="bottom-right"
            hideCloseButton={type === "prompt"}
            renderActions={() => (
                <>
                    <Show if={type === "confirm"}>
                        <button
                            type="button"
                            className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-red-600 text-base font-medium text-white hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 sm:ml-3 sm:w-auto sm:text-sm"
                            onClick={wrapClick(clearAuth)}
                        >
                            Logout
                        </button>
                    </Show>
                    <Show if={type === "prompt"}>
                        <button
                            type="button"
                            className="w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
                            onClick={wrapClick(() => setOpen(false))}
                        >
                            {/* count down timer */}
                            Logs out in {countdown}
                        </button>
                    </Show>
                </>
            )}
        />
    )
}

export default LogoutContainer